import React from 'react';
import EvaluateRules from '../../../Utils/Rules/EvaluateRules';
import FormGroup from '../FormGroup/FormGroup';
import './FormColumn.css';

const FormColumn = (props) => {

    const fieldNotVisible = (formGroups, fieldName) =>  {
        for (const formGroup of formGroups) {
            formGroup.visible = EvaluateRules("visible",formGroup.Rules, props.data);
            columnVisible = formGroup.visible || columnVisible;
    
            if (formGroup.visible) {
                for (const field of formGroup.Fields) {
                    if (field.Id === fieldName) {
                        return false;
                    }
                }
            }
        }
        return true;
    }
    
    let columnVisible = false;
    let formGroups = [...props.config.FormGroups]
    for (const formGroup of formGroups) {
        formGroup.visible = EvaluateRules("visible",formGroup.Rules, props.data);
        columnVisible = formGroup.visible || columnVisible;

        if (! formGroup.visible) {
            for (const field of formGroup.Fields) {
                if (field.value !== undefined && field.value !== null && field.value !== null && fieldNotVisible(formGroups, field.Id)) {
                    props.changeHandler(field.Id, null);
                }
            }
        }
    }

    const formColumnClass = props.multiPage ? "formcolumn-fullscreen" : "formcolumn-2col";

    let columnContents = (null);
    if (columnVisible) {
        columnContents = ([
            <div key={props.config.Key} data-cy={props.config.Key} className={formColumnClass}>
                {formGroups.map((formGroup) => {
                    if (formGroup.visible) {
                        return (
                            <FormGroup key={formGroup.Key} config={formGroup} changeHandler={props.changeHandler} fieldFocusOut={props.fieldFocusOut} language={props.language} id={props.id} onKeyDown={props.onKeyDown}></FormGroup>
                        )
                    } else {
                        return (null)
                    }}
                )}
            </div> 
        ])
    }

    return (
        <React.Fragment>
            {columnContents}    
        </React.Fragment>
    )
};
  
export default FormColumn;